<template>
  <div class="condition-item">
    <span>筛选字段{{ index + 1 }}</span>
    <a-select v-model="list[index].datasource" allowClear placeholder="请选择媒体" @change="changeDataSource" style="width: 150px">
      <a-select-option
        v-for="item in dataSet"
        :key="item.mediaCode"
        :value="item.mediaCode"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-select v-model="list[index].tableId" allowClear placeholder="请选择数据层级" @change="tableChange" style="width: 150px">
      <a-select-option
        v-for="item in tableList"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-select v-model="list[index].dimension"  :filter-option="false"
      placeholder="请选择维度" @search="getDimensionList" 
      @change="dimensionChange"
      show-search
      style="width: 150px"
    >
      <a-select-option v-for="item in dimensionList" :key="item.field" :value="item.field">
        <div :title="item.desc">{{ item.name }}</div>
      </a-select-option>
    </a-select>
    <a-select v-model="list[index].op" style="width: 146px" placeholder="请选择运算符">
      <a-select-option value="like">包含</a-select-option>
      <a-select-option value="notLike">不包含</a-select-option>
      <a-select-option value="startWith">开始以</a-select-option>
      <a-select-option value="notStartWith">开始不是以</a-select-option>
      <a-select-option value="endWith">结束以</a-select-option>
      <a-select-option value="notEndWith">结束不是以</a-select-option>
      <a-select-option value="eq">等于</a-select-option>
    </a-select>
    <icon-font
      class="delete-btn"
      type="icon-Close-Circle-Fill"
      @click="$emit('delete')"
      v-if="list.length > 1"
    ></icon-font>
  </div>
</template>

<script>
import {
  getTables,
  getDimensionList,
} from "@/api/basicCyberData";
import { getEnumDataNew } from "@/api/template";

export default {
  name: "FilterConditionItem",
  props: ["list", "index", 'dataSet'],
  data() {
    return {
      normList: [],
      value: {},
      tableList: [],
      dimensionList: [],
    };
  },
  computed: {
    dataType() {
      return this.list[this.index]?.dataType;
    },
  },
  watch: {
  },
  mounted() {
    if (this.list[this.index]?.datasource) {
      this.getTables();
      this.getDimensionList(this.list[this.index]?.dimensionName || undefined);
    }
  },
  methods: {
    tableChange() {
      let obj = this.tableList.find(v => v.id === this.list[this.index].tableId)
      if(obj) {
        this.list[this.index].tableName = obj.name
      }
      this.list[this.index].dimension = undefined
      this.list[this.index].dimensionName = undefined
      this.getDimensionList()
    },
    dimensionChange() {
      let obj = this.dimensionList.find(v => v.field === this.list[this.index].dimension)
      if(obj) {
        this.list[this.index].dimensionName = obj.name
      }
    },
    async changeDataSource() {
      // 在筛选器组件时，将全局的数据源和账户存储
      // 切换数据源时清空相关信息；
      let obj = this.dataSet.find(v => v.mediaCode === this.list[this.index].datasource)
      if(obj) {
        this.list[this.index].datasourceName = obj.name
      }
      this.list[this.index].tableId = undefined
      this.list[this.index].tableName = undefined
      this.list[this.index].dimension = undefined
      this.list[this.index].dimensionName = undefined
      this.getTables(true)
      this.getDimensionList()
    },
    getTables(datachange) {
      this.tableList = []
      if(this.list[this.index].datasource) {
        getTables(this.list[this.index].datasource).then(res => {
          this.tableList = res.data || []
          if(datachange) {
            if(this.tableList.length === 1) {
              this.list[this.index].tableId = this.tableList[0].id
              this.list[this.index].tableName = this.tableList[0].name
            }
          }
        })
      }
    },
    async getDimensionList(keyWord) {
      this.dimensionList = []
      const params = {
        mediaCode: this.list[this.index].datasource,
      };
      const odata = {
        filterEnable: true,
        searchKeyWord: keyWord,
        tableId: this.list[this.index].tableId
      };
      const { code, data } = await getDimensionList(params, odata);
      if (code != "200") return;
      this.dimensionList = data && data.recordList ? data.recordList : [];
    },
  },
};
</script>
<style lang="less" scoped>
.condition-item {
  height: 48px;
  line-height: 48px;
  width: 100%;
  margin: 4px 0px;
  padding-left: 16px;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  & > * {
    margin-right: 8px;
  }
  .delete-btn {
    position: absolute;
    right: 8px;
    top: 16px;
    color: #9ca9cb;
    font-size: 16px;
    cursor: pointer;
    display: none;
  }
  .enum-select {
    /deep/ .ant-select-selection--multiple {
      height: 32px;
      overflow: hidden;
    }
  }
  &:hover {
    background: #F7F9FE;
    .delete-btn {
      display: block;
    }
  }
}
</style>
